// extracted by mini-css-extract-plugin
module.exports = {"dsersAlert":"_2zbRJ","productTip":"_1SC93"};